<template>
  <q-layout style="background: rgb(244, 244, 250);">
      <q-header style="border: none; background-color: #355dc4 !important;" class="row" >
        <q-toolbar  color="transparent" text-color="white" style="border: none; margin: auto;" class="no-shadow col-xs-12 col-sm-11 col-md-9">
        
        <img :src='companyLogo' class="q-ma-md" style="image-rendering: auto; max-width: 200px; max-height: 55px;"/>
      </q-toolbar>
       </q-header>
    <q-page-container class="no-shadow" borderless>
      <Login />
    </q-page-container>
  <q-footer class="AppFooter transparent" style="background-color:rgba(65,65,65,1) !important; height: 276px;">
    
      <FooterComponent/>
    
  </q-footer>
  </q-layout>
</template>

<script>
import Login from '@/components/LoginScreen.vue'
import FooterComponent from '@/components/FooterComponent.vue'
export default {
name: 'login',
components: {
  Login,
  FooterComponent
},data() {
  return {
      companyLogo: this.$store.getters.getCompanyLogo('white')
    }
  }
}
</script>



<!-- TODO script to call -->
